import React from 'react'
import { ReportScrollArea, ReportTableSurface } from './interactive.styled'

type Props = {
  minWidth: number
  children: React.ReactNode
}

export const ReportTableFrame: React.FC<Props> = ({ minWidth, children }) => (
  <ReportScrollArea>
    <ReportTableSurface $minWidth={minWidth}>{children}</ReportTableSurface>
  </ReportScrollArea>
)
